export default __webpack_public_path__ + "static/media/Singularity.0944be63.svg";